import { Box } from "@mui/material";
import { ToggleViewType } from "src/constants/services";
import { ServicesRowFilled } from "src/Icons/ServicesRowFilled";
import { ServicesRowOutline } from "src/Icons/ServicesRowOutline";
import { ServicesToggleCategoryOutline } from "src/Icons/ServicesToggleCategory";
import { ServicesToggleCategoryFilled } from "src/Icons/ServicesToggleCategoryFilled";

import { ViewChangeButton } from "../../screens/services/components/ViewChangeButton/ViewChangeButton";

import { ViewChangePickerProps } from "./ViewChangePicker.types";

export function ViewChangePicker ({
  toggleView,
  onChange,
}: ViewChangePickerProps) {
  return (
    <Box
      sx={{
        cursor: "pointer",
        display: "flex",
      }}
    >
      <ViewChangeButton
        onClick={() => {
          onChange(ToggleViewType.colum);
        }}
        Icon={
          toggleView === ToggleViewType.colum
            ? ServicesToggleCategoryFilled
            : ServicesToggleCategoryOutline
        }
        sx={{
          fontSize: "34px",
          borderTopLeftRadius: "6px",
          borderBottomLeftRadius: "6px",
          color: toggleView === ToggleViewType.colum ? "black" : "#9D9D9D",
        }}
      />
      <ViewChangeButton
        onClick={() => {
          onChange(ToggleViewType.row);
        }}
        Icon={
          toggleView === ToggleViewType.row
            ? ServicesRowFilled
            : ServicesRowOutline
        }
        sx={{
          fontSize: "25px",
          borderTopRightRadius: "6px",
          borderBottomRightRadius: "6px",
          color: toggleView === ToggleViewType.row ? "black" : "#9D9D9D",
        }}
      />
    </Box>
  );
}